import ProductSamplesClass from '../../components/product-samples/product-samples';
import { Constants } from './samples-constants';
import { GlobalState } from '../../global-state/global-state';

const addToSamplesButtonProps = {
  productId: {
    type: Number | String,
    required: false,
  },
  productKitWeight: {
    type: Number,
    required: false,
  },
  productKit: {
    type: Boolean,
    default: false,
  },
  productHandle: {
    type: String,
    required: true,
  },
  productTags: {
    type: String,
  },
  addSampleLocation: {
    type: String,
    default: 'Product Card',
  },
};

export const AddToSamplesButton = {
  name: 'product-add-to-samples-button',
  template: `<button v-if="!disabledSampleButton && availableForSamples" type="button" class="vue-c add-to-samples-cta cta-button mt-2" v-bind:data-add-to-samples="productHandle" v-bind:data-sample-handle="productHandle" v-bind:data-selected-variant-id="productId" v-on:click="addToProductSamples($event)" :class="getClass()" v-bind:disabled="disabledSampleButton">
    <p class="cta-button__text">{{ buttonText }}</p>
  </button>`,
  props: addToSamplesButtonProps,
  data() {
    return {
      buttonText: Constants.els.requestSampleButtonText,
      disabledSampleButton: window.theme && window.theme.samplingDisabled,
      productSampleClass: new ProductSamplesClass(this),
      availableForSamples: true,
      sharedState: GlobalState.state,
    };
  },
  mounted() {
    this.isProductAvailableForSampling(this.productTags);
  },
  methods: {
    addToProductSamples: function (event) {
      // Security guard: prevent sampling if disabled globally
      if (this.disabledSampleButton) {
        return;
      }
      
      // this.disabledSampleButton = true;
      this.productSampleClass.addToProductSamples(event.currentTarget.dataset.selectedVariantId, this.productHandle, this.addSampleLocation, ['true', true].includes(this.productKit), this.productKitWeight);

      setTimeout(() => {
        this.productSampleClass.checkForSampleLimit();
        this.disabledSampleButton = false;
        this.$emit('sample-added');
      }, 1000);
    },
    getClass: function () {
      const classes = [];
      if (this.disabledSampleButton) {

        classes.push('cta-button--grey');
        classes.push('cta-button--disabled');
      } else {
        classes.push('cta-button--green');
      }
      if (this.productKit) {
        classes.push('kit');
      }
      return classes.join(' ');
    },
    isProductAvailableForSampling: function (tags) {
      if (!tags) {
        return;
      }
      /**
       * This method leverages the Product Sample Class methods.
       * It checks whether or not a product is available for
       * sampling, by looking through the product tags for a tag called:
       * 'disable_product_samples'
       * –
       * Tags are coming through as a string.
       * Convert to an array and pass through to method.
       */
      const tagsArray = tags.split(',');
      const SampleNotAvailable =
        this.productSampleClass.checkProductSampleAvailablity(tagsArray);
      SampleNotAvailable
        ? (this.availableForSamples = false)
        : (this.availableForSamples = true);
    },
    // updateButtonState: function() {
    //   const isKit = ['true', true].includes(this.productKit);
    //   const text = getSampleButtonText(this.productHandle, isKit, isKit ? this.productKitWeight : 1);
    //   this.buttonText = text;
    //   this.disabledSampleButton = shouldDisabledSampleButton(text);
    // }
  },
};
